<template>
	<div class="col-12 col-md-6 col-lg-3">
		<div class="small">
			{{ label }}
		</div>
		<div class="dropdown b-dropdown w-100 mb-3 btn-group">
			<button type="button" class="btn dropdown-toggle btn-selector-block" @click="toggleDropdownList">
				{{ labelValue }}
			</button>
		</div>
		<div v-show="show" v-out-click="closeDropdownList" class="dropdown-list">
			<input ref="searchInput" v-model.trim="search" class="dropdown-input" type="text" autofocus>
			<div v-if="labelAnyValue !== false" v-show="itemVisible('')" class="dropdown-item" @click="selectItem('')">
				{{ labelAnyValue }}
			</div>
			<div v-for="(option, id) in options" v-show="itemVisible(option)" :key="id" class="dropdown-item" @click="selectItem(id)">
				{{ option }}
			</div>
		</div>
	</div>
</template>

<script>
import { outClick } from '@/directives';

export default {
	name: 'Dropdown',
	directives: { outClick },
	model: {
		prop: 'value',
		event: 'change',
	},
	props: {
		options: {
			type: [Array, Object],
			required: true,
		},
		label: {
			type: String,
			required: true,
		},
		labelAnyValue: {
			type: [String, Boolean],
			default: 'Все',
		},
		value: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			search: '',
			show: false,
		};
	},
	computed: {
		labelValue() {
			return this.options[this.value] || this.labelAnyValue;
		},
	},
	methods: {
		itemVisible(item) {
			const currentName = item.toLowerCase();
			const currentInput = this.search.toLowerCase();
			return currentName.includes(currentInput);
		},
		selectItem(option) {
			this.show = false;
			this.search = '';
			this.$emit('change', option);
		},
		closeDropdownList() {
			setTimeout(() => {
				this.$nextTick(() => { this.show = false; });
			}, 0);
		},
		toggleDropdownList() {
			setTimeout(() => {
				this.show = !this.show;
				this.search = '';
				if (this.show) {
					this.$nextTick(() => this.$refs.searchInput.focus());
				}
			}, 0);
		},
	},
};
</script>

<style lang="scss" scoped>
.dropdown-input, .dropdown-selected{
	width: 100%;
	padding: 10px 25px;
	line-height: 1.5em;
	border-radius: 8px;
	border: 1px solid #aaa;
	outline-offset: -2px;
}
.dropdown-input:focus, .dropdown-selected:hover{
	background: #fff;
	border-color: #e2e8f0;
}
.dropdown-input::placeholder{
	opacity: 0.7;
}
.dropdown-selected{
	font-weight: bold;
	cursor: pointer;
}
.dropdown-list{
	position: absolute;
	width: 100%;
	max-height: 500px;
	margin-top: 4px;
	overflow-y: auto;
	background: #ffffff;
	box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
	z-index: 1020;
	background-clip: padding-box;
	border: 1px solid rgba(0, 0, 0, 0.15);
	border-radius: 0;
}
.dropdown-item{
	display: flex;
	width: 100%;
	cursor: pointer;
}
</style>
